(() => {
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);

  const updateProductTotal = (input) => {
    const form = input.closest('.product-form');
    const total = form?.querySelector('[data-c2g-pdp-total]');
    if (!total) return;

    const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
    const unitPrice = Number.parseInt(total.dataset.unitPrice, 10) || 0;
    total.textContent = money(quantity * unitPrice);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches('.template-product .quantity-input-field')) {
      updateProductTotal(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.template-product .quantity-input-field')) {
      updateProductTotal(event.target);
    }
  });

  document.addEventListener('click', (event) => {
	const viewBtn = event.target.closest('[data-c2g-view]');
	if (viewBtn) {
	  const isList = viewBtn.dataset.c2gView === 'list';
	  document.documentElement.classList.toggle('c2g-view-list', isList);
	  try { localStorage.setItem('c2g-view', isList ? 'list' : 'grid'); } catch (e) { /* private mode */ }
	  return;
	}

	const filterToggle = event.target.closest('[data-c2g-sidebar-toggle]');
	if (filterToggle) {
	  const layout = filterToggle.closest('.facets-wrap');
	  if (!layout) return;

	  const isCollapsed = layout.classList.toggle('c2g-filters-collapsed');
	  const label = filterToggle.querySelector('[data-c2g-sidebar-toggle-label]');
	  filterToggle.setAttribute('aria-expanded', String(!isCollapsed));
	  filterToggle.setAttribute('aria-label', isCollapsed ? 'Show filters' : 'Hide filters');
	  if (label) label.textContent = isCollapsed ? 'Show Filters' : 'Hide Filters';
	  return;
	}

    const button = event.target.closest('.template-product .quantity-input-button');
    if (!button) return;
    requestAnimationFrame(() => {
      const input = button.closest('quantity-input')?.querySelector('.quantity-input-field');
      if (input) updateProductTotal(input);
    });
  });
})();
